import type * as ents from '@attain-apps/entities'
export interface State {
  /** Indicates whether the page configuration dialog is opened */
  presentPageConfiguration: boolean
  /** Containing the current page configuration being edited. */
  editingPageConfiguration: Partial<
    Omit<ents.core.mosaic.Page.Input | ents.core.mosaic.Page.Updates, 'content'>
  >
}

export namespace State {
  export const INITIAL: Readonly<State> = {
    editingPageConfiguration: {},
    presentPageConfiguration: false,
  }
}
